import type { ButtonHTMLAttributes, PropsWithChildren } from 'react'
import cls from './button.module.css'

export type ButtonVariant = 'fill' | 'outline' | 'ghost'
export type ButtonSize = 'large' | 'small'

export type UIButtonProps = PropsWithChildren<
  {
    variant?: ButtonVariant
    size?: ButtonSize
    className?: string
  } & ButtonHTMLAttributes<HTMLButtonElement>
>

export default function Button({ variant = 'fill', size = 'large', className = '', disabled, children, ...rest }: UIButtonProps) {
  const classes = [cls.btn, cls[variant], cls[size], disabled ? cls.disabled : '', className].filter(Boolean).join(' ')

  return (
    <button className={classes} disabled={disabled} {...rest}>
      {children}
    </button>
  )
}
